// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lpz6q","input":"styles_input__T5t1T"};